/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbs_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_shipment">;
    readonly " $refType": "PdpRespSidebarBlurbs_shipment";
};
export type PdpRespSidebarBlurbs_shipment$data = PdpRespSidebarBlurbs_shipment;
export type PdpRespSidebarBlurbs_shipment$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_shipment$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_shipment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_shipment"
    }
  ],
  "type": "Shipment",
  "abstractKey": null
};
(node as any).hash = 'ff7ebb3ab63532c1e23839d8b3ffcb98';
export default node;
